import type { QueryKey, UseQueryResult, UseQueryOptions, QueryOptions } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import client from "@/api/client/axios";
import type { GetCategoriesQueryResponse, GetCategories400, GetCategories401, GetCategories403, GetCategories422, GetCategories429, GetCategories500 } from "../types/GetCategories";

export const getCategoriesQueryKey = () =>     [{url:`/api/purchase-tenders/pub/v1/categories`}] as const;
      export function getCategoriesQueryOptions <TData = GetCategoriesQueryResponse, TError = GetCategories400 | GetCategories401 | GetCategories403 | GetCategories422 | GetCategories429 | GetCategories500>(options: Partial<Parameters<typeof client>[0]> = {}): UseQueryOptions<TData, TError> {
        const queryKey = getCategoriesQueryKey();

        return {
          queryKey,
          queryFn: () => {
            
            return client<TData, TError>({
              method: "get",
              url: `/api/purchase-tenders/pub/v1/categories`,
              
              
              ...options,
            }).then(res => res.data);
          },
        };
      };
      
/**
 * @link /api/purchase-tenders/pub/v1/categories
 */

export function useGetCategories <TData = GetCategoriesQueryResponse, TError = GetCategories400 | GetCategories401 | GetCategories403 | GetCategories422 | GetCategories429 | GetCategories500>(options: {
          query?: UseQueryOptions<TData, TError>,
          client?: Partial<Parameters<typeof client<TData, TError>>[0]>,
        } = {}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const { query: queryOptions, client: clientOptions = {} } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getCategoriesQueryKey();

  const query = useQuery<TData, TError>({
    ...getCategoriesQueryOptions<TData, TError>(clientOptions),
    ...queryOptions
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey as QueryKey;

  return query;
};
